// @flow

import React from "react";
import classNames from "classnames";

import optionResolver from "../utils/options";
import type { SchemaTableWidgetProps } from "../types";

import styles from "./text.scss";

export type TextWidgetState = $Exact<{
  touched: boolean,
}>;

export class TextWidget extends React.Component<SchemaTableWidgetProps<string>, TextWidgetState> {
  state = {
    touched: false,
  };

  componentDidUpdate(prevProps: SchemaTableWidgetProps<string>) {
    // this will only happen as part of a request to hide errors
    if (!this.props.touched && prevProps.touched) {
      this.setState({ touched: false });
    }
  }

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(event.currentTarget.value);
  };

  handleTouched = (event: SyntheticEvent<HTMLInputElement>) => {
    this.setState({ touched: true });
  };

  hasUiSchemaError = (value: string): boolean => {
    if (!this.state.touched) {
      return false;
    }

    if (this.props.required && (!value || !value.trim().length)) {
      return true;
    }

    const options = this.props.options || {};

    const minLength = optionResolver.resolveNumber(options.minLength, this.props.row);
    if (minLength && value && value.length < minLength) {
      return true;
    }

    const maxLength = optionResolver.resolveNumber(options.maxLength, this.props.row);
    if (maxLength && value && value.length > maxLength) {
      return true;
    }

    return false;
  };

  hasError = (value: string): boolean => {
    return !!this.props.error || this.hasUiSchemaError(value);
  };

  render() {
    const disabled = optionResolver.resolveBoolean(
      (this.props.options || {}).disabled,
      this.props.row,
    );

    if (!this.props.active) {
      return (
        <div className={classNames("text__readonly", { text__disabled: disabled })}>
          {this.props.data}
        </div>
      );
    }

    return (
      <div
        className={classNames("flex-1", {
          "form-input--required": this.props.required,
        })}
      >
        <input
          type="text"
          value={this.props.data}
          required={this.props.required}
          disabled={disabled}
          maxLength={this.props.maxLength}
          minLength={this.props.minLength}
          readOnly={this.props.readOnly}
          onChange={this.handleChange}
          onBlur={this.handleTouched}
          className={classNames("form-control", this.props.className)}
        />
      </div>
    );
  }
}

export default TextWidget;
